<template>
    <div class="py-2">
        <form class="form" :id="id" @saveAndRefresh="saveAndRefresh">
            <input type="hidden" name="_method" :value="method" />

            <slot :saveAndRefresh="saveAndRefresh" />

            <form-submit
                v-if="! read_only"
                :method="method"
                :url="url"
                :id="id"
                background_color="bg-white"
                @saved="saved"
            />
        </form>
    </div>
</template>

<script>
import FormSubmit from './form-submit.vue';

export default {
    components: {
        FormSubmit,
    },

    props: {
        id: {},
        method: {},
        url: {},
        read_only: { default: false },
    },

    methods: {
        saved(response) {
            this.$emit('saved', response);

            if (response?.progress) {
                store.state.property_progress_sections = Object.assign({}, response.progress);
            }

            if (response?.progressOverall) {
                store.state.property_progress_overall = response.progressOverall;
            }
        },
        saveAndRefresh() {
            let form = document.querySelector('#' + this.id);
            let data = new FormData(form);

            axios.post(this.url, data)
                .then(response => {
                    window.location.reload();
                }).catch(error => {
                    console.log(error);
                });
        },
    },

    mounted() {
        const qs = new URLSearchParams(window.location.search);
        const field = qs.get('field');

        if (field) {
            let input = document.getElementById(field);

            if (input) {
                this.$nextTick(() => {
                    input.focus();
                });
            }
        }
    },
}
</script>
